import { IconName } from 'components-ds/Icon/Icon';

export const industryCodeToIcon: {
  [key: string]: IconName;
} = {
  '01': 'trades',
  '02': 'retail',
  '03': 'foodBeverageHospitality',
  '04': 'professionalService',
  '05': 'healthBeauty',
  '06': 'propertyOwnersAccommodation',
  '07': 'transportLogistics',
  '08': 'artMedia',
  '09': 'sportRecreationClubsAssociations',
  '10': 'manufacturingWholesaling',
  '11': 'governmentEducationReligion',
  '12': 'agricultureMiningUtilities',
  '14': 'accommodation',
};

export const occupationCategoryCodeToIconList: {
  [key: string]: IconName;
} = {
  '021': 'clothingAndAccessoriesRetail',
  '026': 'groceryAndFoodRetail',
  '027': 'homewareRetail',
  '022': 'beautyPharmaceuticalRetail',
  '0211': 'paperProductsRetail',
  '025': 'gardenRetail',
  '0212': 'petrolAndVehicleServicingRetail',
  '0214': 'secondHandGoodsRetail',
  '023': 'furnitureAndAccessoriesRetail',
  '0215': 'sportToysCampingRetail',
  '029': 'jewelleryRetail',
  '024': 'electricalRetail',
  '0210': 'motorVehicleRetail',
  '028': 'householdEquipmentRepair',
  '0213': 'retailOther',

  '0416': 'consultants',
  '0417': 'healthBeautyServices',
  '0411': 'accountants',
  '0413': 'architectAndBuildingServices',
  '0415': 'businessAdministrativeSupportServices',
  '044': 'personalServices',
  '043': 'informationTechnology',
  '046': 'industryAssociations',
  '042': 'finance',
  '048': 'legalServices',
  '0412': 'advertising',
  '0414': 'arts',
  '041': 'freightAndTravelServices',
  '047': 'insuranceActuarial',
  '0410': 'realEstater',
  '049': 'other',

  '019': 'constructionAndSitePreparation',
  '014': 'landscapingGardening',
  '017': 'cleaningAndPestControl',
  '012': 'constructionServices',
  '013': 'electricalAndFireAndSecuritySystems',
  '0112': 'plumbing',
  '0113': 'tilingCarpetingFlooring',
  '016': 'carpentingAndWoodworking',
  '015': 'plasteringRenderingCladdingRoofing',
  '011': 'airconditioningAndHeating',
  '0111': 'paintingAndDecorating',
  '018': 'concretingBricklaying',
  '0110': 'glazing',

  '032': 'takeAwayFoodDrink',
  '031': 'cafesAndRestaurants',
  '034': 'groceryAndFoodRetail',
  '035': 'licensedClubsAndVenues',
  '033': 'barsHotelsAndClubs',

  '051': 'hairdressingAndBeautyServices',
  '0510': 'hospitals',
  '0511': 'nursingHomes',
  '052': 'healthServices',
  '053': 'specialistMedicalServices',
  '054': 'dentalServices',
  '055': 'communityHealthCentres',
  '056': 'optometry',
  '057': 'veterinaryServices',
  '058': 'petServices',
  '059': 'ambulanceServices',

  '071': 'roadFreightTransport',
  '0710': 'servicesToRoadTransport',
  '0711': 'servicesToAirTransport',
  '0712': 'transportOther',
  '072': 'storageFacilities',
  '073': 'busTransport',
  '074': 'freightForwarding',
  '075': 'railWaterAirTransport',
  '076': 'taxiAndOtherRoadPassengerTransport',
  '077': 'servicesToWaterTransport',
  '078': 'parkingServices',
  '079': 'waterTransportTerminals',

  '081': 'videoOrAudio',
  '082': 'photography',
  '083': 'visualArtists',
  '084': 'performanceArt',
  '085': 'artsOrMediaEquipmentHire',
  '086': 'writingOrPublishing',
  '087': 'entertainmentVenue',
  '088': 'otherArtsOrMediaServices',
  '089': 'archivalServices',

  '091': 'gymsStudiosOrOtherFacilities',
  '0910': 'sportsCentresOrStadiums',
  '0911': 'motorsportsOrFirearms',
  '0912': 'otherSportsRecreationOrClubs',
  '092': 'instructorsTrainersOrOutdoorGuides',
  '093': 'communityUnionsOrAssociations',
  '094': 'horsesOrDogs',
  '095': 'gearAndEquipmentHire',
  '096': 'gamesRidesOrEntertainment',
  '097': 'grassSportsOrWatersports',
  '098': 'gambling',
  '099': 'parksOrOutdoorRecreationFacilities',

  '101': 'personalOrHouseholdGoodsWholesaling',
  '102': 'metalProductManufacturing',
  '103': 'basicMaterialWholesaling',
  '104': 'foodOrBeverageManufacturing',
  '105': 'vehicleMachineryOrEquipmentWholesaling',
  '106': 'woodOrPaperProductManufacturing',
  '107': 'vehicleMachineryOrEquipmentManufacturing',
  '108': 'otherManufacturing',
  '109': 'mineralNonmetalProductManufacturing',
  '1010': 'printOrRecordedMediaManufacturing',
  '1011': 'clothingOrTextilesManufacturing',
  '1012': 'chemicalOrFuelProductManufacturing',

  '111': 'education',
  '112': 'government',
  '113': 'religion',

  '121': 'agriculture',
  '122': 'mining',
  '123': 'utilities',

  '141': 'accommodationCategory',
};
